import "./javascripts/components/MoviesDiscoveryManager/MoviesDiscoveryManager.js";